module.exports = __webpack_public_path__ + "assets/08463646157788d8ab6cd84452c3e5a4.wav";